module.exports = __webpack_public_path__ + "fonts/b1503d6.woff2";